import { useNavigate } from 'react-router-dom';

/**
 * Custom hook for managing business navigation and workflow actions
 * Encapsulates navigation logic for reviews, editing, and business workflows
 */
export const useBusinessNavigation = ({ token, businessId, title, profileData, ownerView }) => {
  const navigate = useNavigate();

  // Helper function for authentication check
  const requireAuth = (callback) => {
    if (!token) {
      navigate('/auth/signin', { 
        state: { 
          name: 'businessDetails', 
          link: `/business/${businessId}/${title}` 
        } 
      });
      return false;
    }
    return callback();
  };

  // Write review handler
  const handleWriteReview = () => {
    return requireAuth(() => {
      console.log('Navigating to write review for', profileData.businessName);
      const feedbackProps = {
        skillName: profileData.skillName,
        skillPhoto: profileData.photoUrl,
        skillId: profileData.skillId,
        spId: profileData.spId,
        businessId: profileData._id,
        businessName: profileData.businessName,
        skill: profileData
      };

      navigate('/feedback', { state: feedbackProps });
    });
  };

  // Business owner navigation handlers
  const handleEditBusinessDetails = () => {
    console.log('Navigating to business details edit');
    // The edit form is seeded from router state and used RAW — it can only
    // send back fields present here. specialFeatures, keywords and
    // additionalInfo moved to the owner endpoint when the public projection
    // became an inclusion list; without merging ownerView they arrive
    // undefined, render blank, and are written as "" on the next save.
    navigate(`/business/${profileData._id}/edit`, {
      state: { ...profileData, ...(ownerView || {}) },
    });
  };

  const handleViewStats = () => {
    navigate(`/business/admin/${profileData._id}`);
  };

  // Business workflow handlers
  const handleStartVerification = () => {
    console.log('Initiating business verification process');
    // TODO: Start verification workflow
  };

  const handleUnclaim = () => {
    console.log('Unclaiming business');
    // TODO: Implement business unclaim logic
  };

  return {
    handlers: {
      handleWriteReview,
      handleEditBusinessDetails,
      handleViewStats,
      handleStartVerification,
      handleUnclaim
    }
  };
};